import { Box, BoxProps, ColorOptions, Text, TextProps } from '@jfs/ui-new'
import { TextInputNew } from '../AdminInputs'
import React, { forwardRef } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

export const CustomDatePickerInput = forwardRef(
  ({ value, onClick, label, labelFontFamily, labelColor, labelPaddingBottom, error, rightComponent }: any, ref) => {
    return (
      <div className="customDatePickerInput" onClick={onClick} ref={ref}>
        <TextInputNew
          onPressIn={onClick}
          value={value}
          label={label}
          onFocusBorderWidth={1}
          color={'BLACK_21' as ColorOptions}
          paddingHorizontal={16}
          selectionColor={'BLUE'}
          paddingVertical={9}
          type="body12"
          borderColor={'#d1d3e2' as ColorOptions}
          borderRadius={4}
          fontSize={12}
          labelFontFamily={labelFontFamily}
          labelColor={labelColor}
          touched={true}
          labelPaddingBottom={labelPaddingBottom}
          error={error}
          rightComponent={rightComponent}
        />
      </div>
    )
  },
)

const isDate = function (date: string) {
  return new Date(date).toString() !== 'Invalid Date'
}

const TableDatePickerReact = ({
  label,
  labelPaddingBottom = 10,
  labelFontFamily = 'jiotype-bold',
  labelFontSize = 12,
  labelColor = '#757575',
  timeInputLabel,
  dateFormat = 'dd-MM-yyyy',
  showTimeInput,
  setFieldValue,
  fieldName,
  maxDate = new Date(),
  dateValue = '',
  minDate,
  error,
  from = '',
  rightComponent = undefined,
  onDateChanged,
}: any) => {
  const datePickerRef = React.useRef(null)

  const onChangeHandle = (val: Date) => {
    onDateChanged(fieldName, val)
  }

  console.log('dateValue', dateValue)

  return (
    <Box {...styles.container}>
      <DatePicker
        onChange={onChangeHandle}
        selected={dateValue}
        dateFormat={dateFormat}
        timeInputLabel={timeInputLabel}
        showTimeInput={showTimeInput}
        portalId="modal-root"
        ref={datePickerRef}
        shouldCloseOnSelect={false}
        maxDate={maxDate}
        minDate={minDate}
        customInput={
          <CustomDatePickerInput
            label={label}
            labelPaddingBottom={labelPaddingBottom}
            labelFontFamily={labelFontFamily}
            labelFontSize={labelFontSize}
            labelColor={labelColor}
            value={dateValue}
            error={error}
            rightComponent={rightComponent}
          />
        }>
        <Box {...styles.buttonContainer}>
          <Box
            {...styles.button}
            onPress={() => {
              datePickerRef.current.setOpen(false)
            }}>
            <Text {...styles.buttonText}>OK</Text>
          </Box>
        </Box>
      </DatePicker>
    </Box>
  )
}

export { TableDatePickerReact }

const styles = {
  container: {
    w: '100%',
  } as BoxProps,
  buttonContainer: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'center',
  } as BoxProps,
  button: {
    p: 5,
    width: 50,
    borderRadius: 40,
    alignItems: 'center',
    backgroundColor: 'PRIMARY',
  } as BoxProps,
  buttonText: {
    color: 'WHITE',
  } as TextProps,
}
